import { Action, combineReducers } from 'redux';

import { broadcastReducer } from '~src/broadcasts/reducers/BroadcastReducer';
import { customDomainEnabledReducer } from '~src/customDomain/redux/CustomDomainEnabledReducer';
import { normalizedContentReducer } from '~src/home/reducers/NormalizedContentReducer';
import { recommendationsReducer } from '~src/recommendations/reducers/RecommendationsReducer';
import { resourceActionsReducer } from '~src/resourceActions/reducers/ResourceActionsReducer';
import { privateConnectReducer } from '~src/settings/privateconnect-settings/reducers/PrivateConnectReducer';
import { CredentialEncryptionReducer } from '~src/settings/security-settings/sections/credential-encryption/reducers/CredentialEncryptionReducer';
import { extractEncryptionReducer } from '~src/settings/security-settings/sections/extract-encryption/reducers/ExtractEncryptionReducer';
import { linkEnabledSiteReducer } from '~src/siteManagement/reducers/LinkEnabledSiteReducer';
import { siteAdminResourcesReducer } from '~src/siteManagement/reducers/SiteAdminResourcesReducer';
import { siteCountAndCloudAdminStatusReducer } from '~src/siteManagement/reducers/SiteCountAndCloudAdminStatusReducer';
import { sitesAndTenantsInfoReducer } from '~src/siteManagement/reducers/SitesAndTenantsInfoReducer';
import { assetListReducer } from '~src/spacesPlatform/reducers/AssetListReducer';
import { availableActionsForEntityReducer } from '~src/spacesPlatform/reducers/AvailableActionsForEntityReducer';
import { breadcrumbsReducer } from '~src/spacesPlatform/reducers/BreadcrumbsReducer';
import { contentExplorerReducer } from '~src/spacesPlatform/reducers/contentExplorer/ContentExplorerReducer';
import { spaceInfoReducer } from '~src/spacesPlatform/reducers/contentExplorer/SpaceInfoReducer';
import { incrementRouterSpaceReactKeyReducer } from '~src/spacesPlatform/reducers/IncrementRouterSpaceReactKeyReducer';
import { layoutTypeReducer } from '~src/spacesPlatform/reducers/LayoutTypeReducer';
import { navigationReducer } from '~src/spacesPlatform/reducers/NavigationReducer';
import { orderReducer } from '~src/spacesPlatform/reducers/OrderReducer';
import { routerErrorReducer } from '~src/spacesPlatform/reducers/RouterErrorReducer';
import { serverUsersSpaceReducer } from '~src/userManagement/reducers/ServerUsersSpaceReducer';

import { alertListInfoReducer } from '../../../dda/reducers/AlertListInfoReducer';
import { draftsReducer } from '../../../drafts/reducers/DraftsReducer';
import { homeReducer } from '../../../home/reducers/HomeReducer';
import { containerInfoReducer } from '../../../personalSpace/reducers/ContainerInfoReducer';
import { personalSpaceReducer } from '../../../personalSpace/reducers/PersonalSpaceReducer';
import { rootAdminUiStateReducer } from '../../../rootAdminUi/RootAdminUiStateReducer';
import { sitesReducer } from '../../../siteManagement/reducers/SitesReducer';
import { displaySettingsReducer } from '../../../spacesPlatform/reducers/DisplaySettingsReducer';
import { starterReducer } from '../../../starters/reducers/StarterReducer';
import { uploadContentReducer } from '../../../uploadContent/reducers/UploadContentReducer';
import { userNotificationSettingsReducer } from '../../../userNotifications/redux/UserNotificationSettingsReducer';
import { userNotificationsReducer } from '../../../userNotifications/redux/UserNotificationsReducer';
import { userSettingsReducer } from '../../../userSettings/reducers/UserSettingsReducer';
import { AppState } from '../state/AppState';
import { sessionReducer } from './SessionReducer';
import { siteMetadataReducer } from './SiteMetadataReducer';
import { vizPathReducer } from './VizPathReducer';

export const appReducer: (
  previousState: AppState,
  action: Action
) => AppState = combineReducers<AppState>({
  alertListInfo: alertListInfoReducer,
  assetList: assetListReducer,
  availableActionsForEntities: availableActionsForEntityReducer,
  breadcrumbs: breadcrumbsReducer,
  contentExplorer: contentExplorerReducer,
  normalizedContentById: normalizedContentReducer,
  displaySettings: displaySettingsReducer,
  order: orderReducer,
  session: sessionReducer,
  siteMetadata: siteMetadataReducer,
  userSettings: userSettingsReducer,
  spaceInfo: spaceInfoReducer,
  navigationState: navigationReducer,
  sites: sitesReducer,
  home: homeReducer,
  layoutType: layoutTypeReducer,
  rootAdminUiState: rootAdminUiStateReducer,
  vizPath: vizPathReducer,
  routerSpaceReactKey: incrementRouterSpaceReactKeyReducer,
  reduxRouterError: routerErrorReducer,
  recommendations: recommendationsReducer,
  starters: starterReducer,
  uploadContent: uploadContentReducer,
  drafts: draftsReducer,
  notificationState: userNotificationsReducer,
  notificationSettingsState: userNotificationSettingsReducer,
  personalSpace: personalSpaceReducer,
  containerInfo: containerInfoReducer,
  serverUsersSpace: serverUsersSpaceReducer,
  broadcast: broadcastReducer,
  customDomainEnabled: customDomainEnabledReducer,
  isLinkEnabledSite: linkEnabledSiteReducer,
  sitesAndTenantsInfo: sitesAndTenantsInfoReducer,
  siteCountAndCloudAdminStatus: siteCountAndCloudAdminStatusReducer,
  siteAdminResources: siteAdminResourcesReducer,
  resourceActions: resourceActionsReducer,
  privateConnectInfo: privateConnectReducer,
  extractEncryptionInfo: extractEncryptionReducer,
  credentialEncryptionInfo: CredentialEncryptionReducer
});
